import { atom } from 'recoil';

import { CartType } from '~/types/cart';

const cartType = atom<CartType>({
  key: 'cartType',
  default: CartType.CART_PERSONAL,
});

export default cartType;
